<template>
    	<div class="profile-sidebar notmobile_menu">
            <div class="widget-profile pro-widget-content">
                <div class="profile-info-widget">
                    <a href="#" class="booking-doc-img">
                        <img src="@/assets/img/user2.jpg" alt="User Image">
                    </a>
                    <div class="profile-det-info">
                        <h3>{{user.namauser}}</h3>
                        <div class="receiver-details">
                            <h5>{{(user.hak_akses== '2')?"Instruktur":"-"}}</h5>
                            <!-- <h5 class="mb-0"><i class="fas fa-map-marker-alt"></i> Newyork, USA</h5> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="dashboard-widget">
                <nav class="dashboard-menu">
                    <ul>
                        
                    <template v-if="user.hak_akses == '2'">
                        <li v-bind:class="{'active': currentPath == 'instructor-profile-settings'}">
                            <router-link to="/instructor/profile-settings">
                                <i class="fas fa-user-cog"></i>
                                <span>Identitas Diri</span>
                            </router-link>
                        </li>
                        <li v-bind:class="{'active': currentPath == 'instructor-instansi'}">
                            <router-link to="/instructor/instansi">
                                <i class="fas fa-building"></i>
                                <span>Instansi</span>
                            </router-link>
                        </li>
                        <!-- <li v-bind:class="{'active': currentPath == 'instructor-rekam-jejak'}">
                            <router-link to="/instructor/rekam-jejak">
                                <i class="fas fa-history"></i>
                                <span>Rekam Jejak</span>
                            </router-link>
                        </li> -->
                        <li v-bind:class="{'active': currentPath == 'instructor-penugasan'}">
                            <router-link to="/instructor/penugasan">
                                <i class="fas fa-briefcase"></i>
                                <span>Penugasan</span>                       
                                <!-- <small  class="unread-msg badge badge-pill bg-primary-light p-2">NEW</small>                                                                -->
                                <small class="unread-msg">{{cntPenugasan}}</small>
                            </router-link>
                        </li> 
                        <li v-bind:class="{'active': currentPath == 'instructor-wallet'}">
                            <router-link to="/instructor/wallet">
                                <i class="fas fa-wallet"></i>
                                <span>Keuangan</span>
                                <small  class="unread-msg badge badge-pill bg-primary-light p-2">NEW</small>                                                               
                                <!-- <small  class="unread-msg badge badge-pill bg-warning-light">Coming Soon</small>                                 -->
                            </router-link>
                        </li>
                        
                        <!-- <li v-bind:class="{'active': currentPath == 'instructor-materi'}">
                            <router-link to="/instructor/materi">
                                <i class="fas fa-list"></i>
                                <span>Manajemen Materi</span>
                            </router-link>
                        </li> -->
                        <li v-bind:class="{'active': currentPath == 'instructor-tryout'}">
                            <router-link to="/instructor/tryout">
                                <i class="fas fa-list"></i>
                                <span>Manajemen Try Out</span>
                            </router-link>
                        </li>
                        <!-- <li v-bind:class="{'active': currentPath == 'instructor-kelas-saya'}">
                            <router-link to="/instructor/kelas-saya">
                                <i class="fas fa-calendar-check"></i>
                                <span>Manajemen Paket</span>
                                <small class="unread-msg">{{cntPaket}}</small>
                            </router-link>
                        </li>  -->
                        <li v-bind:class="{'active': currentPath == 'instructor-kelas-saya'}">
                            <router-link to="">
                                <i class="fas fa-calendar-check"></i>
                                <span>Kelas Pendidik</span>
                                <small  class="unread-msg badge badge-pill bg-warning-light">Coming Soon</small>                                
                                <!-- <small class="unread-msg">23</small> -->
                            </router-link>
                        </li> 
                        <!-- <li v-bind:class="{'active': currentPath == 'instructor-dashboard'}">
                            <router-link to="">
                                <i class="fas fa-columns"></i>
                                <span>#LearnDoTeach</span>
                                <small  class="unread-msg badge badge-pill bg-warning-light">Coming Soon</small>                                
                            </router-link>
                        </li>                         -->
                        <!-- <li v-bind:class="{'active': currentPath == 'siswa-chat'}">
                            <router-link to="">
                                <i class="fas fa-comments"></i>
                                <span>Referral</span>
                                <small  class="unread-msg badge badge-pill bg-warning-light">Coming Soon</small>                                
                            </router-link>
                        </li>   -->
                        <li>                            
                            <a @click="logout">
                                <i class="fas fa-sign-out-alt"></i>
                                <span>Keluar</span>
                            </a>
                        </li>
                    </template>

                    </ul>
                </nav>
            </div>
            <div class="widget-profile pro-widget-content">
                <div class="profile-info-widget">
                    <a href="https://wa.me/+6285183033543" target="_blank" class="booking-doc-img  bg-white">
                        <img src="@/assets/img/cs2.jpg" alt="User Image">
                    </a>
                    <div class="profile-det-info">
                        <p>Anda mengalami kesulitan? <br>silahkan klik tombol berikut</p>
                        <div class="receiver-details">
                            <a href="https://wa.me/+6285183033543" target="_blank" class="btn btn-sm bg-warning">
                                 Hubungi Kami
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import Util from '../../../assets/utils/utils'
import {mapGetters} from 'vuex'
import axios from 'axios';

export default {
    data() {
        return {
            cntPaket: 0, cntPenugasan: 0
        }
    },
    computed: {
        ...mapGetters({ 
            isLoggedIn: 'isLoggedIn',
            user: 'user',
        }),
        currentPath() {
            return this.$route.name
        }
    },
    created: function () {
        this.getCntPaket();
        this.getCntPenugasan();
    },
    methods: { 
        
        logout: function() {
            this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
            });
        },
        getCntPaket: function () {
            axios.get('api/cntpaketinst/'+localStorage.getItem('idUser'))
                .then(res => {
                    this.cntPaket = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
        getCntPaket: function () {
            axios.get('api/cntpenugasaninst')
                .then(res => {
                    this.cntPenugasan = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Instructor/Sidebar/index.vue